import { render, staticRenderFns } from "./directSmsAction.vue?vue&type=template&id=31aed3df"
import script from "./directSmsAction.vue?vue&type=script&lang=js"
export * from "./directSmsAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports